export default __webpack_public_path__ + "static/media/whatsapp_grey.0f15ec7d.svg";